// extracted by mini-css-extract-plugin
export default {"container":"_87c7c45"};